"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerEpic = exports.rootEpic = void 0;
var redux_observable_1 = require("redux-observable");
var BehaviorSubject_1 = require("rxjs/BehaviorSubject");
require("rxjs/add/operator/mergeMap");
var epicRegistry = [];
var epic$ = new BehaviorSubject_1.BehaviorSubject(redux_observable_1.combineEpics());
var rootEpic = function (action$, store) {
    return epic$.mergeMap(function (epic) { return epic(action$, store, null); });
};
exports.rootEpic = rootEpic;
function registerEpic(epic) {
    // don't add an epic that is already registered/running
    if (epicRegistry.indexOf(epic) === -1) {
        epicRegistry.push(epic);
        epic$.next(epic);
    }
}
exports.registerEpic = registerEpic;
//# sourceMappingURL=epicRegistry.js.map